import React, { useMemo } from 'react';
import ImageWithFallback from './ImageWithFallback';
import VerifiedBadge from './VerifiedBadge';
import { UserStories } from './StoriesViewer';
import { auth } from '../firebase';

interface StoriesRailProps {
  groups: UserStories[];
  onOpen: (userIndex: number) => void;
}

const StoriesRail: React.FC<StoriesRailProps> = ({ groups, onOpen }) => {
  const uid = auth.currentUser?.uid || 'anon';
  const seenSet = useMemo(() => {
    try {
      const raw = localStorage.getItem(`stories_seen_${uid}`);
      const arr = raw ? (JSON.parse(raw) as string[]) : [];
      return new Set(arr);
    } catch {
      return new Set<string>();
    }
  }, [uid]);

  return (
    <div style={styles.railWrap}>
      <div style={styles.railScroll}>
        {groups.map((g, idx) => {
          const hasUnseen = g.items.some(it => !seenSet.has(it.id));
            const ringStyle = hasUnseen ? styles.gradientRing : styles.seenRing;
            return (
              <div key={g.userId} style={styles.item} onClick={() => onOpen(idx)}>
                <div style={ringStyle}>
                  <div style={styles.innerRing}>
                    <ImageWithFallback src={g.userPhoto} alt="" style={styles.avatar} />
                  </div>
                </div>
                <div style={styles.name}>
                {g.userName?.split(' ')[0] || 'User'}
                {g.userVerified ? <VerifiedBadge size={12} /> : null}
              </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  railWrap: { marginBottom: 16 },
  railScroll: { display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 6 },
  item: { display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' },
    gradientRing: {
      width: 64, height: 64, borderRadius: '50%', padding: 2,
      background: 'conic-gradient(#f58529, #feda77, #dd2a7b, #8134af, #515bd4, #f58529)'
    },
    seenRing: {
      width: 64, height: 64, borderRadius: '50%', padding: 2,
      background: 'linear-gradient(180deg, #D7DFDF, #C7D1D1)'
    },
    innerRing: {
      width: '100%', height: '100%', borderRadius: '50%', padding: 3,
      background: 'var(--color-surface)', display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
  avatar: { width: 54, height: 54, borderRadius: '50%', objectFit: 'cover' as const, background: '#eee' },
  name: { marginTop: 6, fontSize: 12, color: 'var(--color-text)' },
};

export default StoriesRail;

